export const LOCALSTORAGE_ENV_FILTER_KEY = 'umojoUtilsEnvTypeFilter';
export const LOCALSTORAGE_FREQUENTLY_USED_KEY = 'umojoUtilsFrequentlyUsedIds';
export const LOCALSTORAGE_CATEGORY_FILTER_KEY = 'umojoUtilsCategoryFilter'; 
export const MAX_FREQUENTLY_USED_ITEMS = 5; // Max items to store and display